import React from 'react';
import classNames from 'classnames';
import { Collapsible } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import ChevrondownIcon from 'icons/Chevrondown.icon';
import RfiPieChart from './components/RfiPieChart';
import RfiAnalyticsTable from './components/RfiAnalyticsTable';

import './RfiAnalytics.styles.scss';
import './RfiAnalytics.styles.responsive.scss';

type RfiAnalyticsProps = {
  className?: string;
};

const RfiAnalytics: React.FC<RfiAnalyticsProps> = (props) => {
  const { className } = props;

  const classes = classNames('rfi-analytics', 'white-panel', className);

  const { t } = useTranslation();

  return (
    <Collapsible
      className={classes}
      trigger={
        <div className="trigger">
          <p>{t('analytics')}</p>
          <ChevrondownIcon />
        </div>
      }
    >
      <RfiPieChart />
      <RfiAnalyticsTable />
    </Collapsible>
  );
};

export default RfiAnalytics;
